// unwrapGroup — VQE-Edit edit-action: drop an explicit WHERE group's parens,
// lifting its children into the parent. Delegates to SR-Edit `unwrap-group`.

import type { BooleanClauseTarget, NodePath } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Remove the parentheses around the explicit, non-negated group at
 * `groupPath`, in the WHERE (default) or HAVING (`clause: 'having'`) tree.
 * No-op for implicit / negated groups (SR-Edit returns no planned edits).
 */
export async function unwrapGroup(
  groupPath: NodePath,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  await commitEdit({ op: 'unwrap-group', groupPath, clause }, ctx);
}
